export async function fetchRolePermissions(userResponse) {
  try {
    const email = userResponse.email
    if (!email) return

    const { buildApiUrl, ADMIN_ENDPOINTS } = await import('@/project/configs/api.js')

    // Step 1: Find the current user in the teammates list to get their role name
    const teammatesUrl = buildApiUrl(ADMIN_ENDPOINTS.ADMIN_TEAMMATES, {
      queryParams: { service: 'rapidoo-admin' }
    })
    const teammatesRes = await fetch(teammatesUrl).then(r => r.json())

    if (!teammatesRes?.data) return

    const teammate = teammatesRes.data.find(t => t.email === email)
    if (!teammate?.role) return

    // Step 2: Fetch all roles to find the matching role's permissions
    const rolesUrl = buildApiUrl(ADMIN_ENDPOINTS.ADMIN_ROLES, {
      queryParams: { service: 'rapidoo-admin' }
    })
    const rolesRes = await fetch(rolesUrl).then(r => r.json())

    if (!rolesRes?.data) return

    const matchedRole = rolesRes.data.find(r => r.name === teammate.role)
    if (matchedRole?.permissions) {
      userResponse.permissions = matchedRole.permissions
    }
  } catch (err) {
    console.error('Failed to fetch role permissions:', err)
  }
}
